module.exports = __webpack_public_path__ + "static/media/arrows-resize.09f5bdbc.svg";